export const API_URL = 'https://w-ord.ntelgnt.com/proxy.php';